import { PageHeader } from 'ui/pageHeader';
import { PAGE_HEADER_VARIANTS } from 'ui/pageHeader/constants';
import { DOCUMENTATION_URL } from 'modules/segmentation/constants';
import { useListDetailsContext } from 'modules/segmentation/contexts/listDetails';
import { ListSubHeader } from './ListSubHeader';
import { ListName } from './ListName';
import { useTranslation } from '../../hooks';

export const testIds = {
  listViewHeader: 'list-view-header',
};

export const ListViewHeader = () => {
  const { t } = useTranslation();
  const { list } = useListDetailsContext();

  const breadcrumbs = {
    content: 'LISTS',
    href: '/lists',
  };

  return (
    <PageHeader
      data-test={testIds.listViewHeader}
      documentTitle={list.name}
      breadcrumb={breadcrumbs}
      documentation={{ content: t('header.documentation'), href: DOCUMENTATION_URL }}
      variant={PAGE_HEADER_VARIANTS.SECONDARY}
      pageSubSection={<ListSubHeader />}
    >
      <ListName />
    </PageHeader>
  );
};
